<section class="content-layout fullwidth-standard-normal-scroll h-full">
  <!-- HEADER SECTION -->
  <article class="header">
    <div class="container">
      <h1>Sharepoint Integration</h1>
    </div>
  </article>

  <!-- SYNCED SUCCESSFULL TEMPLATE VALIDATION -->
  <ng-container *ngIf="!isSynced; else AlreadySyncedTemplate">
    <!-- API LOADING STATE TEMPLATE VALIDATION -->
    <ng-container *ngIf="!dataSourceIsLoading; else loadingState">
      <!-- BACKEND RESPONSE FAILED TEMPLATE VALIDATION -->
      <ng-container *ngIf="dataSource.data && !isSharePointUndefined; else GenericError">
        <!-- BACKEND RESPONSE FAILED TEMPLATE VALIDATION -->
        <ng-container *ngIf="dataSource.data.length > 1; else EmptyDataTemplate">
          <!-- MAIN CONTENT SECTION  -->
          <article class="w-full h-full rich-text p-10">
            <section class="user-message">
              <h4 class="mb-6">
                Use the folders tree below to access and choose a folder to be synced with Termsheet. You can select
                only one folder at a time.
              </h4>
            </section>
            <!-- MAT-TREE & EXPANDABLE PANEL SECTION -->
            <mat-card>
              <mat-card-content>
                <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
                  <!-- tree node without children -->
                  <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
                    <button mat-icon-button disabled></button>
                    <section *ngIf="!node.item.noMoreFolders" class="w-full flex justify-between items-center">
                      <ng-container *ngIf="node.canSync">
                        <mat-checkbox
                          #parentCheckbox
                          (change)="markCheckNode(parentCheckbox.checked, node)"
                          [disabled]="node.checkDisabled"
                        >
                          <a rel="noopener noreferrer">{{ node.item.name }}</a>
                        </mat-checkbox>
                      </ng-container>
                      <ng-container *ngIf="!node.canSync">
                        <a rel="noopener noreferrer">{{ node.item.name }}</a>
                      </ng-container>
                      <ng-container *ngIf="node.checked">
                        <ng-container *ngIf="node.item.isOneDrive">
                          <button (click)="syncOneDrivePanel()" mat-flat-button type="submit" [color]="'primary'">
                            Sync
                          </button>
                        </ng-container>
                        <ng-container *ngIf="!node.item?.isOneDrive">
                          <button
                            (click)="syncChildNode(node)"
                            [disabled]="node.synced"
                            mat-flat-button
                            [id]="'sync_btn--' + node.item.drive_id"
                            type="submit"
                            [color]="'primary'"
                          >
                            Sync
                          </button>
                        </ng-container>
                      </ng-container>
                    </section>
                    <section *ngIf="node.item.noMoreFolders" class="w-full flex justify-between items-center">
                      {{ node.item.name }}
                    </section>
                  </mat-tree-node>
                  <!-- tree node with children -->
                  <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
                    <button mat-icon-button [attr.aria-label]="'toggle ' + node.item.name" matTreeNodeToggle>
                      <mat-icon class="mat-icon-rtl-mirror">
                        {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                      </mat-icon>
                    </button>
                    <section class="w-full flex justify-between items-center">
                      <article class="flex">
                        <ng-container *ngIf="node.canSync">
                          <mat-checkbox
                            #parentCheckbox
                            (change)="markCheckNode(parentCheckbox.checked, node)"
                            [disabled]="node.checkDisabled"
                          >
                            <a rel="noopener noreferrer">{{ node.item.name }}</a>
                          </mat-checkbox>
                        </ng-container>
                        <ng-container *ngIf="!node.canSync">
                          <a rel="noopener noreferrer">
                            {{ node.item.name === 'OneDrive' ? node.item.name : 'Site: ' + node.item.name }}
                          </a>
                        </ng-container>
                        <mat-spinner *ngIf="node.isLoading" class="ml-2" [diameter]="20" [strokeWidth]="2">
                        </mat-spinner>
                      </article>
                      <ng-container *ngIf="node.checked">
                        <ng-container *ngIf="node.item.isOneDrive">
                          <button (click)="syncOneDrivePanel()" mat-flat-button type="submit" [color]="'primary'">
                            Sync
                          </button>
                        </ng-container>
                        <ng-container *ngIf="!node.item?.isOneDrive">
                          <button
                            (click)="syncChildNode(node)"
                            [disabled]="node.synced"
                            mat-flat-button
                            [id]="'sync_btn--' + node.item.drive_id"
                            type="submit"
                            [color]="'primary'"
                          >
                            Sync
                          </button>
                        </ng-container>
                      </ng-container>
                    </section>
                  </mat-tree-node>
                </mat-tree>
              </mat-card-content>
            </mat-card>
          </article>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</section>

<!-- Successfully synced Template -->
<ng-template #AlreadySyncedTemplate>
  <section class="w-full h-full flex flex-col justify-center items-center">
    <h1>Successfully synced.</h1>
    <h4>You will be redirected shortly...</h4>
  </section>
</ng-template>

<!-- Loading State Template -->
<ng-template #loadingState>
  <ng-container *ngIf="dataSourceIsLoading">
    <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
  </ng-container>
</ng-template>

<!-- Generic Error Template -->
<ng-template #GenericError>
  <section class="w-full h-full flex flex-col justify-center items-center">
    <h1>Oops! Something went wrong...</h1>
    <ng-container *ngIf="isSharePointUndefined">
      <h4>Http failure response. Try again later.</h4>
    </ng-container>
  </section>
</ng-template>

<!-- Empty SharePoint response Template -->
<ng-template #EmptyDataTemplate>
  <section class="w-full h-full flex flex-col justify-center items-center">
    <h1>Oops! Something went wrong...</h1>
    <h4>Unable to fetch all the sites. You can leave this page for now and retry in a few moments.</h4>
  </section>
</ng-template>
